'use client'

import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import quoteLeft from '../../../public/images/Bread 1.svg'
import quoteRight from '../../../public/images/Bread 2.svg'

export const Quote = styled(Typography)(({ theme }) => ({
  color: '#2b3166',
  fontSize: 32,
  lineHeight: 1.25,
  fontWeight: 700,

  marginLeft: theme.spacing(7.5),
  marginRight: theme.spacing(7.5),
  [theme.breakpoints.up('md')]: {
    marginLeft: theme.spacing(25),
    marginRight: 0,
  },

  marginTop: theme.spacing(6),
  position: 'relative',

  '&::before': {
    content: `url("${quoteLeft.src}")`,
    position: 'absolute',
    top: -50,

    left: -50,
    [theme.breakpoints.up('md')]: {
      left: -70,
    },

    height: 61,
    width: 57,
  },

  '&::after': {
    content: `url("${quoteRight.src}")`,
    position: 'absolute',
    top: '95%',

    paddingLeft: theme.spacing(1),

    height: 61,
    width: 57,
  },
}))

export const QuoteAttribution = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  marginLeft: theme.spacing(7.5),
  gap: theme.spacing(1.25),
  alignItems: 'flex-start',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    marginLeft: theme.spacing(25),
    gap: theme.spacing(5.5),
    alignItems: 'center',
  },
}))
